import { appendCloudVersionAfterSegmentAudioChange } from '@/lib/videoEditorCloudSync';

export function narrationEditorId(projectId) {
  return `narration-${projectId}`;
}

/**
 * After narration segment audio is regenerated or an audio version is selected,
 * sync the editor timeline snapshot to the project document.
 */
export async function finalizeNarrationSegmentAudioRegeneration(
  projectId,
  segment,
  { silent = false } = {},
) {
  if (!projectId) return null;
  const segList = Array.isArray(segment) ? segment : [segment];
  if (!segList.some((s) => s?.id)) return null;

  try {
    return await appendCloudVersionAfterSegmentAudioChange(projectId, segList);
  } catch (err) {
    if (!silent) {
      console.warn('Failed to sync editor snapshot after narration audio change', err);
    }
    throw err;
  }
}

/** True when an API response is a narration segment document with audio fields. */
export function isNarrationSegmentAudioResult(data) {
  return Boolean(data?.id && (data.audio_url != null || Array.isArray(data.audio_history)));
}
